<section class="section section--faq" aria-labelledby="faq-title">
  <div class="wrap faq-layout">
    <div class="faq-heading"><h2 class="title" id="faq-title">Frequently asked questions</h2></div>
    <div class="faq-list">
      @for (item of items(); track item.question; let index = $index) {
      <article class="faq-item">
        <h3>
          <button
            type="button"
            class="faq-trigger"
            [attr.aria-expanded]="expandedItems().has(index)"
            [attr.aria-controls]="'faq-panel-' + index"
            [attr.id]="'faq-trigger-' + index"
            (click)="itemToggled.emit(index)"
            [attr.data-testid]="'faq-trigger-' + index"
          >
            <span>{{ item.question }}</span
            ><span class="faq-trigger__icon" aria-hidden="true">{{ expandedItems().has(index) ? "−" : "+" }}</span>
          </button>
        </h3>
        <div
          class="faq-panel"
          [attr.id]="'faq-panel-' + index"
          role="region"
          [attr.aria-labelledby]="'faq-trigger-' + index"
          [hidden]="!expandedItems().has(index)"
        >
          <p>{{ item.answer }}</p>
        </div>
      </article>
      }
    </div>
  </div>
</section>
